import { constants as notificationsConstants, selectors as notificationsSelectors } from 'mage-notifications'
import PropTypes from 'prop-types'
import * as R from 'ramda'
import React from 'react'
import { connect } from 'react-redux'

import RedirectBanner from './RedirectBanner'
import NotificationBanner from './NotificationBanner'
import AlertBanner from './AlertBanner'

const NotificationBanners = ({ notificationBanners }) => notificationBanners.length
  ? (
    <div>
      {
        notificationBanners.map(({ bannerType, id, ...banner }) => {
          switch (bannerType) {
            case notificationsConstants.BANNER_TYPES.ALERT:
              return <AlertBanner key={id} {...banner} />
            case notificationsConstants.BANNER_TYPES.REDIRECT:
              return <RedirectBanner key={id} {...banner} />
            default:
              return <NotificationBanner key={id} {...banner} />
          }
        })
      }
    </div>
  )
  : null

NotificationBanners.propTypes = {
  notificationBanners: PropTypes.array
}

NotificationBanners.defaultProps = {
  notificationBanners: []
}

export default R.compose(
  connect(
    state => ({
      notificationBanners: notificationsSelectors.getSortedFilteredNotifications(state)(notificationsConstants.NOTIFICATION_TYPES.BANNER)
    })
  )
)(NotificationBanners)

export {
  NotificationBanners
}
